export const ROLE_LABELS = {
  ADMIN: "CEO",
  MULTIMEDIA: "Multimédia",
  MARKETEER: "Marketeer",
  TRAFFIC_MANAGER: "Traffic Manager",
  WEB_DEVELOPER: "Web Developer",
  FINANCE: "Accounting Assistant",
  // Legado — ainda renderizado em registos antigos, fora do seletor.
  SUB_ADMIN: "Sub-Administrador",
  SOCIAL_MEDIA: "Social Media",
  DESIGNER: "Designer",
  ACCOUNT_MANAGER: "Gestor de Conta",
};

// Funções que aparecem no seletor ao criar/editar utilizadores.
export const ASSIGNABLE_ROLES = ["ADMIN", "MULTIMEDIA", "MARKETEER", "TRAFFIC_MANAGER", "WEB_DEVELOPER", "FINANCE"];
export const ALL_ROLES = Object.keys(ROLE_LABELS);

/** Lista de funções de um utilizador (novo `roles` ou o `role` legado). */
export function userRoles(u) {
  if (!u) return [];
  return u.roles && u.roles.length ? u.roles : u.role ? [u.role] : [];
}

/** Verdadeiro se o utilizador tem esta função, mesmo não sendo a principal. */
export function hasRole(u, role) {
  return userRoles(u).includes(role);
}

/** Verdadeiro se o utilizador tem pelo menos uma destas funções. */
export function hasAnyRole(u, roles) {
  return roles.some((r) => hasRole(u, r));
}

/** Avenças e propostas: gestão e Accounting Assistant. */
export function hasFinancialAccess(u) {
  return hasAnyRole(u, ["ADMIN", "SUB_ADMIN", "FINANCE"]);
}

/** Etiquetas das funções de um utilizador, ex.: "Web Developer · Traffic Manager". */
export function roleLabel(u) {
  return userRoles(u).map((r) => ROLE_LABELS[r] || r).join(" · ") || "—";
}

export const EVENT_TYPES = {
  REUNIAO: { label: "Reunião", color: "#C967A3" },
  SHOOTING_CLIENTE: { label: "Shooting Cliente", color: "#6B4F91" },
  FERIAS: { label: "Férias", color: "#C62828" },
  TELETRABALHO: { label: "Teletrabalho", color: "#8E9297" },
  EVENTO: { label: "Evento", color: "#477A3A" },
  INDISPONIVEL: { label: "Indisponível", color: "#E57373" },
};

export const TASK_STATUS = {
  A_FAZER: { label: "A Fazer", color: "#94A3B8" },
  EM_PROGRESSO: { label: "Em Progresso", color: "#5B8DEF" },
  AGUARDA_CLIENTE: { label: "Aguarda Cliente", color: "#E5A94C" },
  CONCLUIDO: { label: "Concluído", color: "#4C9A8E" },
};

export const TASK_STATUS_ORDER = ["A_FAZER", "EM_PROGRESSO", "AGUARDA_CLIENTE", "CONCLUIDO"];

/** Estados sem prazo a cumprir: a concluída já foi feita e a que aguarda o
 *  cliente está parada por motivo externo à equipa. */
export const LATE_EXEMPT_STATUS = ["CONCLUIDO", "AGUARDA_CLIENTE"];

/** Tarefa fora de prazo. `today` em AAAA-MM-DD. */
export function isTaskLate(task, today) {
  if (!task?.dueDate) return false;
  if (LATE_EXEMPT_STATUS.includes(task.status)) return false;
  return task.dueDate < today;
}

export const PRIORITY = {
  BAIXA: { label: "Baixa", color: "#94A3B8" },
  MEDIA: { label: "Média", color: "#5B8DEF" },
  ALTA: { label: "Alta", color: "#E5A94C" },
  URGENTE: { label: "Urgente", color: "#D64545" },
};

export const SERVICES = [
  "Tráfego Pago",
  "Gestão de Redes Sociais",
  "Desenvolvimento Web",
  "Design",
  "Branding",
  "Fotografia & Vídeo",
  "Consultoria",
  "SEO",
];

export const CRED_CATEGORIES = [
  "Meta Business Manager",
  "Google Ads",
  "Redes Sociais",
  "WordPress / Hospedagem",
  "Pastas Cloud / Drive",
  "Email",
  "Outro",
];

export const eurFmt = new Intl.NumberFormat("pt-PT", {
  style: "currency",
  currency: "EUR",
});

export const WEEKDAYS_PT = ["Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado", "Domingo"];
